import {
  ERROR_LOADING_LIMITED_NOTIFICATIONS,
  GET_LIMITED_NOTIFICATIONS,
  RESET_LIMITED_NOTIFICATIONS,
  START_LOADING_LIMITED_NOTIFICATIONS,
  STOP_LOADING_LIMITED_NOTIFICATIONS,
} from "./action-types";
import initialState, { LimitedNotification } from "./initialState";

export const limitedNotificationsReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case START_LOADING_LIMITED_NOTIFICATIONS:
      return {
        ...state,
        stateIs: "Pending",
      };

    case ERROR_LOADING_LIMITED_NOTIFICATIONS:
      return {
        ...state,
        stateIs: "Error",
      };

    case STOP_LOADING_LIMITED_NOTIFICATIONS:
      return {
        ...state,
        stateIs: "Idle",
      };

    case GET_LIMITED_NOTIFICATIONS:
      const notifications = action.payload?.notifications?.map(
        (item: LimitedNotification) => {
          const {
            id,
            title,
            description,
            profileImage,
            isRead,
            createdAt,
            redirectLink,
          } = item;
          return {
            id,
            title,
            description,
            profileImage,
            isRead,
            createdAt,
            redirectLink,
          };
        }
      );

      return {
        ...state,
        data: {
          notifications: notifications,
          unreadNotificationCount: action.payload.unreadNotificationCount,
        },
        message: action.message || "",
        stateIs: "Idle",
      };

    case RESET_LIMITED_NOTIFICATIONS:
      return initialState;

    default:
      return state;
  }
};
